/** @format */

import { Component, Inject, OnDestroy, OnInit, Optional } from "@angular/core";
import { NsWISConfigurations } from "../../../models/configurations.model";
import { CONSTANTS_ASSETS_EMP_WEB_EXP } from "../../../constants/assets.constants";
import { NsEmpWebExpData } from "../../../models/emp-web-exp.model";
import { BookingDataService } from "../../../services/booking-data.service";
import { getAdditionalUsersBookings, parkingTypes, getUsersBooking } from "../../../functions/booking-utils.functions";
import { ModalRef } from "mis-design-system/mis-modal";
import { MODAL_DATA_VAR } from "mis-design-system/mis-modal";
@Component({
  selector: "mis-employee-web-exp-booking-confirmation",
  templateUrl: "./booking-confirmation.component.html",
  styleUrls: ["./booking-confirmation.component.scss"]
})
export class BookingConfirmationComponent implements OnInit, OnDestroy {
  Assets = CONSTANTS_ASSETS_EMP_WEB_EXP;
  booking: NsEmpWebExpData.IBookingDetailDTOS;
  offices: NsEmpWebExpData.IOffice[] = [];
  loginPickUp: string = "";
  loginDrop: string = "";
  logoutPickUp: string = "";
  logoutDrop: string = "";
  loginError: string = "";
  logoutError: string = "";
  opt: boolean = false;
  optLogin: boolean = false;
  optLogout: boolean = false;
  empDetails: NsEmpWebExpData.IBookingRequest[];
  displayMsg: string = "";
  transporterr: boolean = false;
  configs: NsWISConfigurations.IConfigurations;
  seatsEnabled: boolean;
  cabsEnabled: boolean;
  mealEnabled: boolean;
  mealDetails: NsEmpWebExpData.IMealsEntity[] = [];
  mealNameArray: string[] = [];
  seatDetails = {
    seat: "",
    floor: "",
    office: ""
  };
  constructor(public bookingSvc: BookingDataService, @Optional() private modalref: ModalRef, @Inject(MODAL_DATA_VAR) configs) {
    this.configs = configs;
  }
  ngOnDestroy(): void {
    this.bookingSvc.createResp = undefined;
  }

  ngOnInit(): void {
    if (!this.bookingSvc.createResp) {
      return;
    }
    const bookingFeatures = this.configs?.BUSettings.features.find(f => f.id === "booking");
    this.seatsEnabled = bookingFeatures?.seatBookingEnabled || false;
    this.cabsEnabled = this.configs?.flattenedSettings.showCabs;
    this.mealEnabled = this.configs?.flattenedSettings.mealPlanningEnabled;
    this.seatDetails = {
      seat: this.bookingSvc.createResp.usersBooking[0].tokenName,
      floor: this.bookingSvc.createResp.usersBooking[0].premiseName,
      office: this.bookingSvc.createResp.usersBooking[0].officeId
    };
    this.mealDetails.pop();
    const parking = getAdditionalUsersBookings(this.bookingSvc.createResp, parkingTypes);
    if (parking?.[0]) this.mealNameArray.push(`Parking: ${parking[0].premiseName}`);
    const mealUserBooking = getUsersBooking(this.bookingSvc.createResp, ["MEALS"])?.[0];
    if (mealUserBooking) this.mealDetails = [...mealUserBooking?.extras?.mealData];
    this.mealDetails.forEach(element => {
      this.mealNameArray.push(element["name"]);
    });

    this.loginDrop = this.bookingSvc.createResp?.loginUserRequestDTO?.tripdetail?.dropLocation?.address;
    this.logoutPickUp = this.bookingSvc.createResp?.logoutUserRequestDTO?.tripdetail?.pickupLocation?.address;
    this.loginError = this.bookingSvc.createResp?.errorMessageForLogInTransport;
    this.logoutError = this.bookingSvc.createResp?.errorMessageForLogoutTranseport;
    if (this.loginDrop && this.logoutPickUp) {
      this.optLogin = true;
      this.optLogout = true;
      this.opt = true;
    } else if (this.loginDrop) {
      this.optLogin = true;
      this.opt = true;
    } else if (this.logoutPickUp) {
      this.optLogout = true;
      this.opt = true;
    } else {
      this.opt = false;
    }
    const schErr = this.bookingSvc.createResp?.errorMessageForLogInTransport || this.bookingSvc.createResp?.errorMessageForLogoutTranseport;
    if (schErr) {
      this.transporterr = true;
      this.displayMsg = schErr;
      this.opt = this.optLogin = this.optLogout = false;
    }
  }
  backHome() {
    this.modalref.close();
  }
}
